import React from 'react';
import { ActionIcon, Tooltip } from "rizzui";
import { PlusIcon, CheckIcon } from "@heroicons/react/24/outline";

function AddAtHomeGroupButton({ onAdd, tooltipText = "Add to Home Service Group", isAdded = false }) {
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Tooltip content={isAdded ? "Already in Home Service Group" : tooltipText} placement="top">
        <ActionIcon
          variant="outline"
          rounded="md"
          size="xs"
          className={isAdded ? "border-green-400 bg-green-50 !w-7 !h-7" : "border-gray-200 !w-7 !h-7"}
          onClick={() => {
            if (!isAdded && onAdd) onAdd();
          }}
        >
          {isAdded ? (
            <CheckIcon className="w-3 h-3 text-green-600" />
          ) : (
            <PlusIcon className="w-3 h-3" />
          )}
        </ActionIcon>
      </Tooltip>
    </span>
  );
}

export default AddAtHomeGroupButton;
